//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	props: ['query', 'items', 'sortitems'],
	computed: {
		...mapState({
			filterDropdown: ({ dropdownStore: {filterDropdown} }) => filterDropdown,
			filter: ({ filtersStore: { filter } }) => filter
		}),
	},
	components: {
		sortModule: () => import('~/components/filters/sortmodule.vue'),
		typefilter: () => import('~/components/filters/filter/typefilter.vue'),
		genres: () => import('~/components/filters/filter/genres.vue'),
		models: () => import('~/components/filters/filter/models.vue'),
		language: () => import('~/components/filters/filter/language.vue'),
		watched: () => import('~/components/filters/sort/watched.vue'),
		recent: () => import('~/components/filters/sort/recent.vue'),
	},
}
